import { useState } from 'react';

export const useAddToAllEstimates = (onCloseCb?: () => void) => {
    const [isAddToAllEstimatesOpen, setIsAddToAllEstimatesOpen] = useState(false);

    const onAddToAllEstimatesClick = () => {
        setIsAddToAllEstimatesOpen(true);
    };
    const onCloseAddToAllEstimates = () => {
        setIsAddToAllEstimatesOpen(false);
        // onCloseCb?.();
    };

    return { isAddToAllEstimatesOpen, onCloseAddToAllEstimates, onAddToAllEstimatesClick };
};
